module.exports = __webpack_public_path__ + "img/new-badge.e2fdd049.svg";